import { useState } from 'react'
import { Button } from '@/components/ui/button'
import DeleteWorkerDialog from '@/frontend/components/DigitalWorkers/DeleteWorkerDialog'

interface Props {
  workerId: string
  instanceName: string
}

export default function DangerZone({ workerId, instanceName }: Props) {
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)

  return (
    <>
      {/* Card da família do DS com a borda na semântica de erro — sem paleta
          crua nem sombra fora do padrão. */}
      <div className="rounded-xl border border-destructive/25 bg-card p-5 space-y-3">
        <h2 className="text-[14px] font-semibold text-destructive">Zona de perigo</h2>
        <div className="flex items-center justify-between gap-4">
          <div>
            <p className="text-[13px] text-foreground">Excluir colaborador digital</p>
            <p className="text-xs text-muted-foreground">Esta ação não pode ser desfeita. Todos os processos vinculados e as integrações atribuídas serão excluídos.</p>
          </div>
          <Button variant="destructive" size="sm" onClick={() => setDeleteDialogOpen(true)}>
            Excluir
          </Button>
        </div>
      </div>
      <DeleteWorkerDialog open={deleteDialogOpen} onOpenChange={setDeleteDialogOpen} workerId={workerId} instanceName={instanceName} />
    </>
  )
}
